<template>
    <hot-modal
      id="hot-publish-modal"
      position="centered"
      :class="{'larger-modal': haveMoreThanOneLink}"
      @close="onCloseModal"
      @open="sendViewEvent"
      :open="publishModal.open"
    >
      <div
        :style="{ backgroundImage: shouldShowBackgroundImageInLargerModal ? 'url(/assets/images/list-publish-modal-image.png)' : 'none'}"
        :class="{'has-background-image': shouldShowBackgroundImageInLargerModal}"
        class="_d-flex _flex-column"
        v-if="justPublishedCheckout && offers[0]"
      >
        <div class="_pb-0 _px-6 _pt-6">
          <h1 class="_text-4 _m-0 _text-gray-700">
            {{ modalHeaderLabel }}
          </h1>
          <button type="button" @click="onCloseModal" class="close-button">
            <font-awesome-icon :icon="['fal', 'times']" size="lg"/>
          </button>
        </div>
        <hot-modal-body class="_pt-3 _flex-1 _d-flex _flex-column">
          <p class="_text-2 _m-0 _text-gray-500">
            {{$t('app.shareYourCheckout')}}
          </p>
          <div class="_mt-8" v-if="!haveMoreThanOneLink">
            <img alt="hotmart features illustration" class="_px-5 _w-full _mb-8" src="/assets/images/publish-modal-image.png"/>
            <published-checkout-link-item
              :showExternalPageButton="false"
              :offer="offers[0]"
              :key="`one-link-modal${offers[0].key}`"
              :customKey="offers[0].key"
              :showButtonsText="true"
              class="_w-full"
              origin="Modal"
              :publicationType="status"
            />
          </div>
          <div class="_d-flex _flex-column links-list" :class="{'_justify-content-end': offers.length < 4}" v-else>
            <published-checkout-link-item
                v-for="(offer) in offers"
                :offer="offer"
                :showExternalPageButton="false"
                class="_mt-4"
                :key="`more-links-modal${offer.key}`"
                :customKey="offer.key"
                :showButtonsText="true"
                origin="Modal"
                :publicationType="status"
            />
          </div>
        </hot-modal-body>
      </div>
      <div v-else class="_d-flex _align-items-center _justify-content-center loading-container">
        <hot-loading></hot-loading>
      </div>
    </hot-modal>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  import PublishedCheckoutLinkItem from 'app/modules/Dashboard/components/PublishedCheckoutLinkItem'
  import log from 'app/log.js'

  export default {
    name: 'publishModal',
    data: function () {
      return {
        isMobileDevice: false
      }
    },
    computed: {
      ...mapState('dashboard', [
        'currentProductHotlinks'
      ]),
      ...mapState('builder', [
        'justPublishedCheckout'
      ]),
      ...mapState('modals', [
        'publishModal'
      ]),
      haveMoreThanOneLink () {
        return this.offers.length > 1
      },
      modalHeaderLabel () {
        return this.haveMoreThanOneLink ? this.$t('app.succesfullPublishedManyLinks', { numberOfOffers: this.offers.length }) : this.$t('app.successfullPublishedOneLink')
      },
      offers () {
        return this.currentProductHotlinks.find(hotlink => hotlink.checkoutId === this.justPublishedCheckout?.id)?.offers ?? []
      },
      status () {
        return this.currentProductHotlinks.find(hotlink => hotlink.checkoutId === this.justPublishedCheckout?.id)?.status ?? 'ACTIVE_BY_OFFER'
      },
      shouldShowBackgroundImageInLargerModal () {
        return this.haveMoreThanOneLink && !this.isMobileDevice
      }
    },
    components: {
      PublishedCheckoutLinkItem
    },
    methods: {
      ...mapMutations('builder', {
        setJustPublishedCheckout: 'SET_JUST_PUBLISHED_CHECKOUT'
      }),
      ...mapMutations('dashboard', {
        clearCheckoutData: 'CLEAR_CHECKOUT_DATA'
      }),
      ...mapActions('modals', {
        closePublishModal: 'CLOSE_PUBLISH_MODAL'
      }),
      ...mapActions('datahubEvents', {
        sendViewSuccessfulPublishModal: 'SEND_VIEW_SUCCESSFUL_PUBLISH_MODAL'
      }),
      onCloseModal () {
        this.clearCheckoutData()
        this.setJustPublishedCheckout({})
        this.closePublishModal()
      },
      sendViewEvent () {
        if (!this.justPublishedCheckout.status) {
          log({
            checkout: JSON.stringify(this.justPublishedCheckout)
          })
          return
        }
        this.sendViewSuccessfulPublishModal(this.justPublishedCheckout.status)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  #hot-publish-modal {
    --modal-padding: var(--spacer-6);
    --modal-border-width: 0px;
  }

  .larger-modal {
    --modal-max-width : 940px;
    --modal-padding: var(--spacer-6) !important;
  }

  .has-background-image {
    height: 417px;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 4px;
  }

  .links-list {
    width: 500px;
    overflow-y: auto;
    height: 280px;
    padding-bottom: 10px;
    padding-right: 10px;
  }

  .close-button {
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: 34px;
    border: 0px;
    background: none;
  }

  .loading-container {
    height: 300px;
  }
</style>
